import { render, staticRenderFns } from "./chemicalMall.vue?vue&type=template&id=aaac0176&scoped=true"
import script from "./chemicalMall.vue?vue&type=script&lang=js"
export * from "./chemicalMall.vue?vue&type=script&lang=js"
import style0 from "./chemicalMall.vue?vue&type=style&index=0&id=aaac0176&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaac0176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaac0176')) {
      api.createRecord('aaac0176', component.options)
    } else {
      api.reload('aaac0176', component.options)
    }
    module.hot.accept("./chemicalMall.vue?vue&type=template&id=aaac0176&scoped=true", function () {
      api.rerender('aaac0176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chemicalMall/chemicalMall.vue"
export default component.exports